import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface InitialState {
    simpleCart: {
        showCart: boolean;
    };
}
const initialState: InitialState = {
    simpleCart: {
        showCart: false
    }
};

const visibilitySlice = createSlice({
    name: "visibility",
    initialState: initialState,
    reducers: {
        updateSimpleCart: (state, action: PayloadAction<InitialState["simpleCart"]>) => {
            state.simpleCart = { ...action.payload };
        }
    }
});

export default visibilitySlice.reducer;
export const { updateSimpleCart } = visibilitySlice.actions;
